export * from "./types";

const PRODUCT = "ballog";
const VERSION = "v2";
const PREFIX = `/${PRODUCT}/${VERSION}`;
const USER = `${PREFIX}/user`;
const TEAM = `${PREFIX}/team`;
const MATCH = `${PREFIX}/match`;
const SEARCH = `${PREFIX}/search`;
const WITHBALL = `${PREFIX}/with_ball`;
const PASSWORD = `${PREFIX}/password`;
const PASSWORD_RESET = `${PASSWORD}/reset`;
const PASSWORD_SEND_RESET_EMAIL = `${PASSWORD_RESET}/notify`;
const RESET_PASSWORD = `${PASSWORD_RESET}/apply`;

export const login = () => `${USER}/login`;

export const register = () => `${USER}/register`;

export const inviteRegister = (inviteCode: string) =>
  `${USER}/register/${inviteCode}`;

export const createTeam = () => `${TEAM}`;

export const getMyTeams = () => `${TEAM}`;

export const getTeams = (userId: number) => `${TEAM}/user/${userId}`;

export const getTeam = (teamId: number) => `${TEAM}/${teamId}`;

export const getUserRoles = (teamId: number) => `${USER}/role/team/${teamId}`;

export const patchTeam = (teamId: number) => `${TEAM}/${teamId}`;

export const getMe = () => USER;

export const searchTeam = () => `${SEARCH}/team`;
export const searchMatch = () => `${SEARCH}/match`;

export const invitePlayerToTeam = (teamId: number) =>
  `${patchTeam(teamId)}/player`;

export const removePlayerFromTeam = (teamId: number) =>
  `${patchTeam(teamId)}/player`;

export const createMatch = () => MATCH;

export const submitMatch = () => `${MATCH}/submit`;

export const postWithballData = () => `${WITHBALL}/add_or_update`;

export const deleteWithballData = () => `${WITHBALL}/id`;

export const getMatch = (matchId: number) => `${MATCH}/${matchId}`;

export const getMatchWithballlData = (matchId: string) => {
  return `${WITHBALL}/match/${matchId}`;
};

export const getMatchTeamWithballlData = (matchId: string, teamId: string) => {
  return `${WITHBALL}/match/${matchId}/team/${teamId}`;
};

export const getTeamWithballlData = (
  teamId: string,
  actions: number[] = [],
  startFrom: string,
  endTo: string
) => {
  return `${WITHBALL}/team/${teamId}?startTime=${startFrom}&endTime=${endTo}&actions=${actions.join(
    ","
  )}`;
};

export const sendResetEmail = () => PASSWORD_SEND_RESET_EMAIL;

export const resetEmail = () => RESET_PASSWORD;

export const updatePlayerNumber = (teamId: number, userId: number) =>
  `${TEAM}/${teamId}/player/${userId}/number`;

export const updatePlayerRoles = (teamId: number, userId: number) =>
  `${TEAM}/${teamId}/player/${userId}/role`;

export const getMatchVideo = () => `/match-video.json`;
